import FamilyModal from './FamilyModal';
export default FamilyModal;
